module.exports = __webpack_public_path__ + "img/3.95be9ea2.jpg";